import { Instance, flow, types } from 'mobx-state-tree';

import { deleteMedia } from '@common/api/media';
import { getTeacher, removeTeacher, saveTeacher } from '@common/api/teachers';
import Program from '@common/models/Programs/Program';
import User from '@common/models/Users/User';

const Teacher = types
	.compose(
		User,
		types.model({
			phone: types.maybeNull(types.string),
			position: types.maybeNull(types.string),
			personal_number: types.maybeNull(types.string),
			zoom_link: types.maybeNull(types.string),
			zoom_id: types.maybeNull(types.string),
			zoom_access_code: types.maybeNull(types.string),
			zoom_on_off: types.maybeNull(types.number),
			miro_link: types.maybeNull(types.string),
			job_title: types.maybeNull(types.string),
			can_impersonate: types.maybeNull(types.boolean),
			is_tutor: types.optional(types.boolean, false),
			is_online: types.optional(types.boolean, false),
			is_offline: types.optional(types.boolean, false),
			programs: types.optional(types.array(Program), []),
		}),
	)
	.named('Teacher')
	.preProcessSnapshot((snapshot: any) => {
		if (!snapshot) return snapshot;
		return {
			...snapshot,
			is_tutor: Boolean(snapshot.is_tutor),
			is_online: Boolean(snapshot.is_online),
			is_offline: Boolean(snapshot.is_offline),
		};
	})
	.actions(() => ({
		_fetch: getTeacher,
		_save: saveTeacher,
		_remove: removeTeacher,
	}))
	.actions((self) => ({
		deleteAvatar: flow(function* () {
			yield deleteMedia({ id: self.user_id, entity: 'users', media_collection: 'avatar' });
			yield self._fetch(self.id);
		}),
	}));

export default Teacher;

export interface ITeacherModel extends Instance<typeof Teacher> {}
